<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="rootPanelTitle"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <tr width="100%" class="no-data-message">
                    <td style="display: inline-block" v-html="$t(rootPanelHint)">
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        rootPanelTitle: {
            type: String,
            required: true,
        },
        rootPanelHint: {
            type: String,
            required: true,
        }
    }
}
</script>

<style scoped>

</style>
